import { useCallback } from 'react';
import { Trans } from 'react-i18next';

const useGetLoginErrorMessage = () => {
  return useCallback(
    ({
      errorCode,
      subscriptionManagementLink,
      subscriptionPaymentDueDays,
    }: {
      errorCode: string;
      subscriptionManagementLink: string | undefined;
      subscriptionPaymentDueDays: number | undefined;
    }) => {
      return (
        <Trans
          i18nKey="pageLogin.error"
          context={errorCode}
          values={{ dueDays: subscriptionPaymentDueDays }}
          components={{
            managementLink: (
              // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/control-has-associated-label
              <a
                href={subscriptionManagementLink}
                rel="noreferrer"
                target="_blank"
              />
            ),
            billingMail: (
              // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/control-has-associated-label
              <a href="mailto:billing@hostfully.com" />
            ),
          }}
        />
      );
    },
    [],
  );
};

export default useGetLoginErrorMessage;
